export default "__VITE_ASSET__C_yHCT2s__";